import React from "react";
import { withRouter } from "react-router-dom";
import {
  FormControl,
  Grid,
  TextField,
  withStyles,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import PropTypes from "prop-types";
import moment from "moment";
import { styles } from "js/components/Shared/TablaFiltro/styles.js";
import DatePicker from "js/components/Shared/Form/Fields/DatePicker";

const AdvancedFilter = ({ value, submitValue, classes }) => {
  // Manejo centralizado de cambios
  const handleChange = e => {
    const { name, value: val } = e.target;
    switch (name) {
      case "idNoticia":
        submitValue({
          target: {
            name,
            value: val === "" ? null : parseInt(val, 10)
          }
        });
        break;
      case "fechaInicio":
        submitValue({
          target: {
            name,
            value: val === "" ? null : { min: new Date(val) }
          }
        });
        break;
      case "fechaFin":
        submitValue({
          target: {
            name,
            value: val === "" ? null : { max: new Date(val) }
          }
        });
        break;
      case "IsActive":
        submitValue({
          target: {
            name,
            value: val === "true" ? true : val === "false" ? false : ""
          }
        });
        break;
      default:
        submitValue(e);
    }
  };

  // Helper para DatePicker
  const getDatePickerValue = key => (value[key] ? moment(value[key]) : null);

  return (
    <Grid container spacing={16}>
      <Grid item xs={12} md={6}>
        <FormControl className={classes.formControl}>
          <TextField
            label="Id Noticia"
            placeholder="Id Noticia"
            name="idNoticia"
            type="search"
            value={value.idNoticia || ""}
            onChange={handleChange}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl className={classes.formControl}>
          <TextField
            name="nombre"
            label="Nombre"
            type="search"
            value={value.nombre || ""}
            onChange={handleChange}
            placeholder="Nombre de la noticia"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl className={classes.formControl}>
          <DatePicker
            name="fechaInicio"
            label="Inicio (fecha de inicio de la noticia)"
            input={{
              onChange: date =>
                submitValue({
                  target: {
                    name: "fechaInicio",
                    value: date ? date.toISOString() : null
                  }
                }),
              value: getDatePickerValue("fechaInicio")
            }}
            format="DD/MM/YYYY"
            maxDate={moment()}
            autoOk
            startOfDate
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl className={classes.formControl}>
          <DatePicker
            name="fechaFin"
            label="Fin (fecha de fin de la noticia)"
            input={{
              onChange: date =>
                submitValue({
                  target: {
                    name: "fechaFin",
                    value: date ? date.toISOString() : null
                  }
                }),
              value: getDatePickerValue("fechaFin")
            }}
            format="DD/MM/YYYY"
            autoOk
            startOfDate
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl className={classes.formControl}>
          <InputLabel id="estado-simple">Estado</InputLabel>
          <Select
            labelId="estado-simple"
            id="IsActive-simple-select"
            value={
              value.IsActive === true
                ? "true"
                : value.IsActive === false
                  ? "false"
                  : ""
            }
            onChange={handleChange}
            inputProps={{
              name: "IsActive",
              id: "IsActive"
            }}
            fullWidth
          >
            <MenuItem value="true">Activo</MenuItem>
            <MenuItem value="false">Inactivo</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

AdvancedFilter.propTypes = {
  value: PropTypes.object.isRequired,
  submitValue: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(AdvancedFilter));
